/**
 * TikTokPixelInit.jsx — Inicialización del pixel para TODOS los usuarios
 *
 * El pixel se activa para todos los visitantes del sitio.
 * Requiere: REACT_APP_TIKTOK_PIXEL_ID seteado en Netlify.
 * Sin ese env var, el componente es un no-op total.
 */
import { useEffect, useRef } from 'react';

export default function TikTokPixelInit() {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;

    const pid = process.env.REACT_APP_TIKTOK_PIXEL_ID;
    if (!pid || pid.startsWith('%') || pid === 'undefined') {
      console.warn('[TikTokPixel] ⚠️ REACT_APP_TIKTOK_PIXEL_ID no está configurado en Netlify.');
      return;
    }

    // El stub de ttq debe estar definido (lo crea index.html)
    if (typeof window.ttq?.load !== 'function') {
      console.warn('[TikTokPixel] ⚠️ window.ttq no disponible. Verifica index.html.');
      return;
    }

    try {
      window.__ttqEvents = [];         // log de eventos para el panel de admin
      window.__ttqActive = true;       // flag que usan las funciones de tiktokPixel.js
      window.__ttqPixelId = pid;       // para mostrar en el panel de debug

      window.ttq.load(pid);
      window.ttq.page?.();

      initialized.current = true;
      console.log('[TikTokPixel] ✅ Pixel activado —', pid);
    } catch (err) {
      console.error('[TikTokPixel] ❌ Error al activar pixel:', err);
    }
  }, []);

  return null; // No renderiza nada visible
}
